import { hashHistory } from 'react-router';

// Get 'app' path
import { path as CPM_PATH } from '../..';

// All paths
const PATHS = {
  PARKINGS: 'parkings',
};

// Exported paths
export const PARKINGS_PATH = PATHS.PARKINGS;

export const listPath = () => `${CPM_PATH}/${PARKINGS_PATH}`;
export const navigateToList = () => {
  hashHistory.push(listPath());
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/navigation.js